import { GridPaginationModel, GridSortModel } from "@mui/x-data-grid";
import { parseAsInteger, parseAsString, UseQueryStatesKeysMap, useQueryStates } from "nuqs";
import { useMemo } from "react";

interface UseTypedQueryStringOptions {
    defaultPageSize?: number;
}

export function useGridQueryState<KeyMap extends UseQueryStatesKeysMap>(
    definition: KeyMap,
    options?: UseTypedQueryStringOptions,
) {
    const [queryState, setQueryState] = useQueryStates({
        ...definition,
        page: parseAsInteger.withDefault(0),
        pageSize: parseAsInteger.withDefault(options?.defaultPageSize ?? 50),
        sortBy: parseAsString,
        sortOrder: parseAsString,
    });

    return useMemo(
        () =>
            [
                queryState,
                setQueryState,
                {
                    onPaginationModelChange: (model: GridPaginationModel) => {
                        setQueryState({ page: model.page, pageSize: model.pageSize } as Parameters<typeof setQueryState>[0]);
                    },
                    onSortModelChange: (model: GridSortModel) => {
                        setQueryState({ sortBy: model[0]?.field ?? null, sortOrder: model[0]?.sort ?? null } as Parameters<
                            typeof setQueryState
                        >[0]);
                    },
                    paginationModel: { page: queryState.page, pageSize: queryState.pageSize } as const,
                    sortModel: queryState.sortBy
                        ? ([{ field: queryState.sortBy, sort: queryState.sortOrder === "asc" ? "asc" : "desc" }] as const)
                        : ([] as const),
                },
            ] as const,
        [setQueryState, queryState],
    );
}
